import * as React from "react";
import type { SVGProps } from "react";
const SvgLightBulb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 21h6"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 17.159v1.066H9v-1.066c0-1.057-.49-2.044-1.306-2.718A6.72 6.72 0 0 1 5.258 9.59c-.185-3.741 2.89-7.03 6.635-7.087A6.75 6.75 0 0 1 18.75 9.25a6.72 6.72 0 0 1-2.47 5.212A3.49 3.49 0 0 0 15 17.159"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.54 15.45h6.91"
    />
  </svg>
);
export default SvgLightBulb;
